import axios from '@/axios';
import coreIAMUrl from '@/apis/coreIAM'

export default {
    fetchAll() {
        return axios.get(`${coreIAMUrl}/admin/apis`);
    },
    fetchOne(uuid) {
        return axios.get(`${coreIAMUrl}/admin/apis/${uuid}`);
    },
    createApi(id, name, description, url, redirectUris, webOrigins) {
        return axios.post(`${coreIAMUrl}/admin/apis`, {
            application_id: id,
            application_name: name,
            application_description: description,
            root_url: url,
            redirect_uris: redirectUris,
            web_origins: webOrigins,
        });
    },
    updateApi(uuid, id, name, description, url, redirectUris, webOrigins) {
        return axios.patch(`${coreIAMUrl}/admin/apis/${uuid}`, {
            application_id: id,
            application_name: name,
            application_description: description,
            root_url: url,
            redirect_uris: redirectUris,
            web_origins: webOrigins,
        });
    },
    deleteApi(uuid) {
        return axios.delete(`${coreIAMUrl}/admin/apis/${uuid}`)
    },
    getApiSecret(uuid) {
        return axios.post(`${coreIAMUrl}/admin/apis/${uuid}/retrieve-secret`);
    },
    getDefaultScopes(uuid) {
        return axios.get(`${coreIAMUrl}/admin/apis/${uuid}/default-scopes`)
    },
    addDefaultScope(uuid, scopeUuid) {
        return axios.post(`${coreIAMUrl}/admin/apis/${uuid}/add-default-scopes`, {
            scope_uuid: scopeUuid
        })
    },
    removeDefaultScope(uuid, scopeUuid) {
        return axios.post(`${coreIAMUrl}/admin/apis/${uuid}/remove-default-scopes`, {
            scope_uuid: scopeUuid
        })
    },
    getOptionalScopes(uuid) {
        return axios.get(`${coreIAMUrl}/admin/apis/${uuid}/optional-scopes`)
    },
    addOptionalScope(uuid, scopeUuid) {
        return axios.post(`${coreIAMUrl}/admin/apis/${uuid}/add-optional-scopes`, {
            scope_uuid: scopeUuid
        })
    },
    removeOptionalScope(uuid, scopeUuid) {
        return axios.post(`${coreIAMUrl}/admin/apis/${uuid}/remove-optional-scopes`, {
            scope_uuid: scopeUuid
        })
    },
    listServiceAccountRoles(uuid) {
        return axios.get(`${coreIAMUrl}/admin/apis/${uuid}/service-account-roles`);
    },
    listServiceAccountAvailableRoles(uuid) {
        return axios.get(`${coreIAMUrl}/admin/apis/${uuid}/service-account-roles/available`);
    },
    addServiceAccountRoles(uuid, roles) {
        return axios.post(`${coreIAMUrl}/admin/apis/${uuid}/service-account-roles/add`, roles);
    },
    removeServiceAccountRoles(uuid, roles) {
        return axios.post(`${coreIAMUrl}/admin/apis/${uuid}/service-account-roles/remove`, roles);
    },
}